import { ITranslationsCollection, ViewController } from '@estee/elc-service';

import { ISocialSignUpProvider } from '~domain/entities/Config';
import { ConfigRepository } from '~repositories/ConfigRepository';
import { TranslationRepository } from '~repositories/TranslationRepository';
import { getSocialSignUpProviderSource } from '~utils/SocialUtils';

export interface IRegisterSuccessViewController {
    configRepository: ConfigRepository;
    translationRepository: TranslationRepository;
}
export class RegisterSuccessViewController extends ViewController {
    private configRepository: ConfigRepository;
    private translations: ITranslationsCollection;
    constructor({ configRepository, translationRepository }: IRegisterSuccessViewController) {
        super();
        this.configRepository = configRepository;
        this.translations = translationRepository.translations;
    }

    public get data() {
        const providerSource = getSocialSignUpProviderSource();
        const provider =
            providerSource && this.configRepository.getSocialSignUpProvider(providerSource);
        const {
            registerSuccess: {
                messageKey = '',
                supportingTextKey = '',
                submitButtonLabelKey = '',
                redirectUrl
            }
        } = { ...provider } as ISocialSignUpProvider;

        return {
            message: this.translations[messageKey],
            supportingText: this.translations[supportingTextKey],
            submitLabel: this.translations[submitButtonLabelKey],
            redirectUrl
        };
    }
}
